import ForceSelectAttribute from "./ForceSelectAttribute";
$(() => {
  if (prestashop.page.page_name == "product") {
    const handler = new ForceSelectAttribute({
      type: "productpage"
    });
    handler.init();
  }
  $(document).on("shown.bs.modal", ".modal.quickview", function() {
    const handler = new ForceSelectAttribute({
      type: "quickview"
    });
    handler.init();
  });
});
if (module.hot) { module.hot.accept(); }